import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_396_1953",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 29,
			height: 29,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 29,
				height: 29,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0_396_1953)" }),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_396_1953",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 29,
			height: 29,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 29,
				height: 29,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_396_1953)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M14.4927 25.375C12.9949 25.375 11.5856 25.0934 10.2648 24.5302C8.94405 23.967 7.78883 23.1905 6.79914 22.2009C5.80948 21.2112 5.03303 20.0559 4.46981 18.7352C3.9066 17.4144 3.625 16.0051 3.625 14.5073C3.625 12.9945 3.90785 11.5779 4.47355 10.2576C5.03923 8.93725 5.81458 7.78459 6.79959 6.79959C7.78459 5.81458 8.94024 5.03922 10.2665 4.47352C11.5928 3.90784 13.004 3.625 14.5 3.625C14.6454 3.625 14.7669 3.67394 14.8646 3.77181C14.9624 3.86969 15.0112 3.99143 15.0112 4.13703C15.0112 4.28262 14.9624 4.40408 14.8646 4.50143C14.7669 4.59877 14.6454 4.64743 14.5 4.64743C11.7761 4.64743 9.453 5.60855 7.53079 7.53079C5.60855 9.45302 4.64743 11.7761 4.64743 14.5C4.64743 17.2239 5.60855 19.547 7.53079 21.4692C9.453 23.3915 11.7761 24.3526 14.5 24.3526C17.2239 24.3526 19.547 23.3915 21.4692 21.4692C23.3915 19.547 24.3526 17.2239 24.3526 14.5C24.3526 14.3539 24.4015 14.2321 24.4994 14.1348C24.5973 14.0375 24.719 13.9888 24.8646 13.9888C25.0102 13.9888 25.1317 14.0376 25.229 14.1354C25.3263 14.2331 25.375 14.3546 25.375 14.5C25.375 15.996 25.0922 17.4072 24.5265 18.7335C23.9608 20.0598 23.1854 21.2154 22.2004 22.2004C21.2154 23.1854 20.0628 23.9608 18.7424 24.5265C17.4221 25.0922 16.0055 25.375 14.4927 25.375Z",
				fill: "#545454"
			})
		})
	]
});
export default SvgLoading;
